/*global VERSION*/

// Important to import before components so that component styles
// can override global ones.
import './styles/global.scss'

import {capitalize} from './utils'
import {install as installModal} from './components/Modal'
import {install as installToastManager} from './components/ToastManager'
import * as components from './components'
import * as utils from './utils/_all'

function install(Vue, options) {
  const opts = options || {
    compatMode: false
  }
  const prefix = opts.prefix
    ? capitalize(opts.prefix)
    : ''

  // Exposes modal APIs under UI global
  Object.assign(this, installModal(Vue))
  installToastManager(Vue)

  Object.keys(components).forEach(name => {
    Vue.component(prefix + name, components[name])
  })

  if (opts.compatMode) {
    document.documentElement.classList.add('ui-compat')
  }
}

export default {
  // Replaced by build
  version: VERSION,
  components,
  install,
  utils,
  format: utils.format
}
